// extracted by mini-css-extract-plugin
export default {"container":"Signup_container__lptOl","form":"Signup_form__MS+Vv","signup":"Signup_signup__y0WvE"};